export enum TournamentTeamStatusEnum {
  Invited = "INVITED",
  Accepted = "ACCEPTED",
  Rejected = "REJECTED",
}
